import React from 'react';
import styles from "./popup-list.module.scss";
import CountryFlag from '../countryFlag/country-flag';
// import { getFreeVisaCountries } from '../../../utils/convert';
// import { isoToCountryMapping } from '../../../data/data-iso-to-country';

const PopUpList = ({data, onClose}) =>{

    // const country = data.country;


    return(
        <div className={`${styles.popupCard}`}>
            <div className={styles.cardHeader}>
                <CountryFlag country={data.name} code={data.code} />
                <div className={`text-right ${styles.noteText}`}>Global visa-free access<br />(out of 226 destinations)</div>
                <button className={styles.closeButton} onClick={onClose}>
                    <svg width="15.2027958px" height="15.2027958px" viewBox="0 0 15.2027958 15.2027958">
                        <g id="Desktop" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                            <g id="destination-overlay" transform="translate(-372.898602, -22.898602)" stroke="#405363">
                                <g id="x" transform="translate(380.500000, 30.500000) rotate(45.000000) translate(-380.500000, -30.500000) translate(374.000000, 24.000000)">
                                    <g id="design/plus-icon" transform="translate(1.250000, 1.000000)">
                                        <line x1="5.25" y1="0" x2="5.25" y2="11" id="Path-3"></line>
                                        <line x1="5.25" y1="0" x2="5.25" y2="10.5" id="Path-3-Copy" transform="translate(5.250000, 5.250000) rotate(-90.000000) translate(-5.250000, -5.250000) "></line>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </svg>
                </button>
            </div>
            <div className={styles.cardBody}>
                <ul>
                    {data.visa_free_list.sort((a, b) =>  a.name.localeCompare(b.name)).map((item, index) => (
                    <li key={index}>
                        <CountryFlag country={item.name} code={item.code} />
                    </li>
                    ))}
                </ul>
            </div>
        </div>
    )
}

export default PopUpList;